import { Box } from '@/ui/primitives';
import type { ReactElement, ReactNode } from 'react';

const inactiveTablePanelSx = {
  display: 'none',
  pointerEvents: 'none',
} as const;

type MountedTableTabPanelProps = {
  active: boolean;
  children: ReactNode;
};

export const MountedTableTabPanel = ({
  active,
  children,
}: MountedTableTabPanelProps): ReactElement => (
  <Box aria-hidden={active ? undefined : true} sx={active ? undefined : inactiveTablePanelSx}>
    {children}
  </Box>
);
